import {
  GET_REVIEWS_REQUEST,
  GET_REVIEWS_SUCCESS,
  GET_REVIEWS_FAILURE,
  CREATE_REVIEW_REQUEST,
  CREATE_REVIEW_SUCCESS,
  CREATE_REVIEW_FAILURE,
  UPDATE_REVIEW_REQUEST,
  UPDATE_REVIEW_SUCCESS,
  UPDATE_REVIEW_FAILURE,
  DELETE_REVIEW_REQUEST,
  DELETE_REVIEW_SUCCESS,
  DELETE_REVIEW_FAILURE,
  GET_REVIEWS_BY_PATIENT_REQUEST,
  GET_REVIEWS_BY_PATIENT_SUCCESS,
  GET_REVIEWS_BY_PATIENT_FAILURE,
  GET_ALL_REVIEWS_ADMIN_SUCCESS
} from '../actions/types';

const initialState = {
  reviews: [],
  allReviews: [],    // <-- [NEW] For Admin page

  loading: false,
  error: null,
  submitting: false,
};

export default function (state = initialState, action) {

  switch (action.type) {
    case GET_REVIEWS_REQUEST:
    case GET_REVIEWS_BY_PATIENT_REQUEST:
    case CREATE_REVIEW_REQUEST:
    case UPDATE_REVIEW_REQUEST:
    case DELETE_REVIEW_REQUEST:
      return {
        ...state,
        loading: action.type === GET_REVIEWS_REQUEST || action.type === GET_REVIEWS_BY_PATIENT_REQUEST,
        submitting: action.type !== GET_REVIEWS_REQUEST && action.type !== GET_REVIEWS_BY_PATIENT_REQUEST,
        error: null
      };

    case GET_REVIEWS_SUCCESS:
    case GET_REVIEWS_BY_PATIENT_SUCCESS:
      return {
        ...state,
        loading: false,
        reviews: action.payload,
        error: null
      };

    case GET_REVIEWS_FAILURE:
    case GET_REVIEWS_BY_PATIENT_FAILURE:
    case CREATE_REVIEW_FAILURE:
    case UPDATE_REVIEW_FAILURE:
    case DELETE_REVIEW_FAILURE:
      return {
        ...state,
        loading: false,
        submitting: false,
        error: action.payload
      };
    case GET_ALL_REVIEWS_ADMIN_SUCCESS:
      return {
        ...state,
        loading: false,
        allReviews:action.payload, // Store all reviews in the new state property
      };

    case CREATE_REVIEW_SUCCESS:
      // The UI re-fetches, so we just stop submitting state.
      return {
        ...state,
        submitting: false,
      };

    case UPDATE_REVIEW_SUCCESS:
      return {
        ...state,
        submitting: false,
        reviews: state.reviews.map(review =>
          review.id === action.payload.id ? { ...review, ...action.payload } : review
        ),
      };

    // --- [CORRECTED] Generic delete case ---
    case DELETE_REVIEW_SUCCESS:
      const idToDelete = action.payload;
      return {
        ...state,
        loading: false, // Ensure loading state is reset
        submitting: false,
        
        // Filter the array for the Doctor Profile page
        reviews: state.reviews.filter(item =>
          item.id !== idToDelete && item.reviewId !== idToDelete
        ),
        
        // ALSO filter the array for the Admin page
        allReviews: state.allReviews.filter(item =>
          item.id !== idToDelete && item.reviewId !== idToDelete
        ),
      };

    default:
      return state;
  }
}